import { filter } from 'rxjs';
import { Component, HostBinding, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { SpinnerService } from './api/spinner.service';
import { AccountInfo } from '@azure/msal-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { UserService } from './data/user/user.service';
import { UserTrackingService } from './api/user-tracking.service';
import { AdminService } from './data/admin/admin.service';
import { ProjectService } from './data/project/project.service';
import { AuthService } from './auth/auth.service';
import { AuthenticationStatus } from './auth/types';
import { isAllowedAnonymousLocation } from './helpers/common/routes-helper';
import { SessionTimeoutService } from './helpers/common/session-timeout.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  @HostBinding('class.app-root-wrapper') classBinding = true;
  protected readonly environment = environment;
  title = 'Kinergy';
  loginDisplay = false;
  account: AccountInfo | undefined;
  displayedColumns: string[] = ['claim', 'value'];
  showSplashScreen = true;
  showGlobalLoadingSpinner = false;
  private forbiddenChars: string;

  constructor(
    public spinnerService: SpinnerService,
    private router: Router,
    public userService: UserService,
    private userTrackingService: UserTrackingService,
    private adminService: AdminService,
    private projectService: ProjectService,
    private authService: AuthService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.adminService.activeFilterCount = 0;
        this.projectService.activeFilterCount = 0;
      }
    });

    spinnerService.isShown().subscribe((isLoading) => {
      this.showGlobalLoadingSpinner = isLoading;
    });
  }

  ngOnInit(): void {

   this.spinnerService.hide();
  this.showGlobalLoadingSpinner = false;

    this.userTrackingService.init();

    this.authService.singIn().subscribe({
      next: () => {
        if (isAllowedAnonymousLocation(window.location.href)) {
          this.showSplashScreen = false;
          return;
        }

        this.userService
          .isUserAuthorizing()
          .pipe(filter((status: AuthenticationStatus) => status !== AuthenticationStatus.InProgress))
          .subscribe({
            next: () => {
              this.showSplashScreen = false;
              this.sessionTimeoutService.startInactivityCheck();
            },
            error: () => {
              this.router.navigate(['/no-access']);
              this.showSplashScreen = false;
            },
          });
      },
      error: () => {
        this.router.navigate(['/no-access']);
        this.showSplashScreen = false;
      },
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.router.url.includes('not-found')) {
        this.showSplashScreen = false;
      }
    });

    // Handle initial load of /signout-oidc
    if (this.router.url === '/signout-oidc') {
      this.showGlobalLoadingSpinner = false;
      this.spinnerService.hide();
    }

   this.router.events.subscribe(event => {
  if (event instanceof NavigationEnd && event.urlAfterRedirects.includes('signout-oidc')) {
    this.spinnerService.hide();
    this.showGlobalLoadingSpinner = false;
  }
});
  }
}